export default __webpack_public_path__ + "static/media/unlock-solid.002c5d2b.svg";